import { ApiService } from './api.service';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  constructor(private api: ApiService) {}

  sendEsqueciSenhaData(data) {
    const endpoint = 'Account/reset-password';
    const route = environment.API_URL + endpoint;
    return this.api.post$(route, data);
  }
}
